module.exports = __webpack_public_path__ + "static/media/money.6fda8be1.svg";